module.exports = __webpack_public_path__ + "f0f4caa1805858ce3580c49417d1a879.pdf";